import type { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 animate-fade-in">
      <div className="w-16 h-16 rounded-2xl bg-surface-lighter/30 flex items-center justify-center mb-5">
        <Icon className="w-8 h-8 text-text-muted/50" />
      </div>
      <h3 className="text-lg font-medium text-text-primary mb-2">{title}</h3>
      <p className="text-sm text-text-muted text-center max-w-xs leading-relaxed">{description}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="mt-5 bg-brand-purple/10 hover:bg-brand-purple/20 text-brand-purple px-5 py-2 rounded-lg text-sm font-medium transition-[color,background-color,transform] duration-200 active:scale-[0.96]"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
